module.exports = __webpack_public_path__ + "img/secure.deaa6760.svg";